<template>
  <div class="mshd">
    <!-- 头部 -->

    <Head style="
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.6) 75%, #ffffff00 25%);
    box-shadow: rgba(142, 142, 142, 0.19) 0px 0px 0px 0px;
    -webkit-box-shadow: rgba(142, 142, 142, 0.19) 0px 0px 0px 0px;"></Head>

    <div class="left_box"
         v-if="isShow">
      <div class="bgc box_1">
        <div class="box_title">主食</div>
        <div class="box_txt">
          <div class="box_img"
               v-if="foodList[0] != ''">
            <el-image v-for="(item, index) in foodList"
                      :key="index"
                      :src="item"
                      :preview-src-list="foodList">
            </el-image>
          </div>
          <span v-if="foodList[0] == ''">暂无图片</span>
        </div>
      </div>
      <div class="bgc box_2">
        <div class="box_title">特色小吃</div>
        <div class="box_txt">
          <div class="box_img"
               style="column-count: 2;"
               v-if="snackList[0] != ''">
            <el-image v-for="(item, index) in snackList"
                      :key="index"
                      :src="item"
                      :preview-src-list="snackList">
            </el-image>
          </div>
          <span v-if="snackList[0] == ''">暂无图片</span>
        </div>
      </div>
      <div class="bgc box_3">
        <div class="box_title">特色饮品</div>
        <div class="box_txt">
          <div class="box_img"
               v-if="drinksList[0] != ''">
            <el-image v-for="(item, index) in drinksList"
                      :key="index"
                      :src="item"
                      :preview-src-list="drinksList">
            </el-image>
          </div>
          <span v-if="drinksList[0] == ''">暂无图片</span>
        </div>
      </div>
    </div>

    <RightBox_2></RightBox_2>
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import RightBox_2 from '@/components/RightBox_2.vue'
import bus from '../../utils/bus.js'


export default {
  components: {
    Head, RightBox_2
  },
  data () {
    return {
      spanArr: [],
      pos: '',
      dialogName: '',
      pathName: '',
      dialogVisible: false,
      foodList: [],
      snackList: [],
      drinksList: [],
      isShow: false,
      city_id: '0'
    }
  },
  mounted () {
    this.getData()

    bus.$on('mapBus', (date) => {
      this.city_id = date.city_id
      this.getData(date)
    })
  },
  methods: {
    getData (date) {
      let newDate = ''
      if (date)
      {
        newDate = date.region
        console.log('市', newDate);

        switch (newDate)
        {
          case '张家界市':
            this.city_id = 0
            break;

          case '湘西州':
            this.city_id = 1
            break;

          case '永州市':
            this.city_id = 2
            break;

          case '怀化市':
            this.city_id = 3
            break;

          case '郴州市':
            this.city_id = 4
            break;

          case '邵阳市':
            this.city_id = 5
            break;

          case '常德市':
            this.city_id = 6
            break;

          case '长沙市':
            this.city_id = 7
            break;

          case '益阳市':
            this.city_id = 8
            break;

          case '湘潭市':
            this.city_id = 9
            break;

          case '娄底市':
            this.city_id = 10
            break;

          case '岳阳市':
            this.city_id = 11
            break;

          case '衡阳市':
            this.city_id = 12
            break;

          case '株洲市':
            this.city_id = 13
            break;
        }
      } else
      {
        newDate = '永州市'
        console.log('市', newDate);
      }

      var date = JSON.parse(localStorage.getItem("date"))
      console.log(date[this.city_id], '数据');
      var date = date[this.city_id]
      // 特色主食图片
      var foodList = date.clist.map((item) => {
        return item.food_img
      })
      var newfoodList1 = foodList.filter((item) => {
        return item != null
      })
      var newfoodList = newfoodList1.filter((item) => {
        return item != ""
      })
      newfoodList = newfoodList.join('、')
      this.foodList = newfoodList.split('、')
      console.log(this.foodList, '特色主食图片');

      // 特色小吃图片
      var snackList = date.clist.map((item) => {
        return item.snack_img
      })
      var newSnackList1 = snackList.filter((item) => {
        return item != null
      })
      var newSnackList = newSnackList1.filter((item) => {
        return item != ""
      })
      newSnackList = newSnackList.join('、')
      this.snackList = newSnackList.split('、')
      console.log(this.snackList, '特色小吃图片');

      // 特色饮品图片
      var drinksList = date.clist.map((item) => {
        return item.drinks_img
      })
      var newDrinksList1 = drinksList.filter((item) => {
        return item != null
      })
      var newDrinksList = newDrinksList1.filter((item) => {
        return item != ""
      })
      newDrinksList = newDrinksList.join('、')
      this.drinksList = newDrinksList.split('、')
      console.log(this.drinksList, '特色饮品图片');

      this.isShow = true
    }
  },
}
</script>

<style lang="less" scoped>
.left_box {
  display: flex;
  width: 74%;
  height: 87vh;
  padding: 1vh;

  .box_1,
  .box_2,
  .box_3 {
    position: relative;
    padding: 5vh;
    flex: 1;
    text-align: center;
    box-shadow: rgba(142, 142, 142, 0.19) 0px 0px 0px 0px;
    -webkit-box-shadow: rgba(142, 142, 142, 0.19) 0px 0px 0px 0px;

    .box_title {
      margin-bottom: 5vh;
      font-size: calc(100vw * 30 / 1920);
      font-weight: 1000;
      font-family: "黑体";
    }

    .box_txt {
      height: 67vh;
      overflow-y: scroll;
      overflow-x: hidden;
      // -webkit-column-break-inside:avoid;
      .box_img {
        column-count: 1; //想要排成的列数
        column-gap: 0.5vh;
        img {
          width: 100%;
        }
      }
    }

    .box_txt::-webkit-scrollbar {
      display: none;
    }
  }

  .box_2:before,
  .box_3:before {
    content: "";
    position: absolute;
    left: 0;
    top: 10%;
    bottom: auto;
    right: auto;
    height: 80%;
    width: 5px;
    background-color: #61C9FF;
  }
}
</style>